import styled from "styled-components";

export const StyleBox = styled.div`
  margin-bottom: 90px;
`;


export const SaveButton = styled.p`
  text-align: right;
`;